module.exports = __webpack_public_path__ + "img/Vendas.935d3322.png";